import React from 'react'
import clsx from 'clsx'
import Link from '../TravelokaLink'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

export const ActiveLink = ({
  alt,
  href,
  title,
  onClick,
  children,
  prefetch,
  className,
  activeClass,
  ...restProps
}) => {
  const router = useRouter()
  const newClassNames = clsx({ active: href === router.pathname }, className || {})

  const hrefProps = {
    ...(!!alt ? { alt } : {}),
    ...(!!onClick ? { onClick } : {}),
  }

  return (
    <Link href={href} prefetch={!prefetch} {...restProps}>
      <a className={newClassNames} {...hrefProps}>
        {children !== '' ? children : title}
      </a>
    </Link>
  )
}

ActiveLink.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  prefetch: PropTypes.bool,
  activeClass: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  alt: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  router: PropTypes.object,
}

ActiveLink.defaultProps = {
  href: '',
  prefetch: true,
  className: 'active',
  alt: '',
  children: '',
  title: 'title',
  router: {},
}

export default ActiveLink
